import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import { ToastProvider } from '../context/ToastContext';

const MainLayout = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <ToastProvider>
            <Navbar />
            <main className="site-main">
                {children}
            </main>
            <Footer />
        </ToastProvider>
    );
};

export default MainLayout;
